import React from "react";
import CartHeader from "../components/checkout/CartHeader";
import CheckoutBody from "../components/checkout/CheckoutBody";

const CheckoutPage = () => (
  <>
    <CartHeader />
    <CheckoutBody />
  </>
);

export default CheckoutPage;
